import React from 'react';
import {
  CalendarMonthOutlined as PlanningIcon,
  GroupsOutlined as GroupsIcon,
  HomeOutlined as HomeIcon,
  ReceiptLongOutlined as TransactionsIcon,
  SettingsOutlined as SettingsIcon,
} from '@mui/icons-material';

export interface NavItem {
  key: 'home' | 'transactions' | 'groups' | 'planning' | 'settings';
  path: string;
  icon: React.ReactElement;
}

/** The four places of the app, in the order the sidebar lists them. */
export const mainNav: NavItem[] = [
  { key: 'home', path: '/dashboard', icon: <HomeIcon /> },
  { key: 'transactions', path: '/transactions', icon: <TransactionsIcon /> },
  { key: 'planning', path: '/planning', icon: <PlanningIcon /> },
  { key: 'groups', path: '/contexts', icon: <GroupsIcon /> },
];

export const settingsNav: NavItem = { key: 'settings', path: '/settings', icon: <SettingsIcon /> };

/** "/settings/telegram" belongs to Ajustes, "/transactions?x" to Lançamentos. */
export const isActivePath = (pathname: string, path: string) =>
  pathname === path || pathname.startsWith(`${path}/`);
